import { Component, h, Host, Prop, State, Listen, Watch } from '@stencil/core';

@Component({
  tag: 'lilu-carousel',
  styleUrl: 'lilu-carousel.scss',
  shadow: true,
})
export class LiluCarousel {
  @Prop() images: string;
  @Prop() dataProductUrl: string;
  @Prop() showBeautyShot = false;
  @State() showControls = false;
  @State() internalImages: string[] = [];
  @State() imageIndex = 0;

  beautyShotLoaded: boolean = false;

  @Listen('imgLoaded')
  onImgLoadedHandler(evt) {
    if (!this.beautyShotLoaded && this.internalImages.length > 1 && evt.detail.imgUrl !== this.internalImages[1]) {
      this.preload_image(this.internalImages[1]);
    }
  }

  componentWillLoad() {
    this.parseImages();
    if (this.internalImages.length > 1) {
      this.showControls = true;
    }
  }

  preload_image(im_url:string) {
    const img = new Image();
    img.src = im_url;
    this.beautyShotLoaded = true;
  }

  @Watch('images')
  parseImages() {
    if (this.images !== undefined) {
      this.internalImages = JSON.parse(this.images);
    }
  }

  @Watch('showBeautyShot')
  switchToBeatuyShot() {
    if (this.showBeautyShot) {
      this.imageIndex = this.internalImages.length >= 2 ? 1 : this.imageIndex;
    } else {
      this.imageIndex = 0;
    }
  }

  previousImage() {
    this.imageIndex === 0 ? (this.imageIndex = this.internalImages.length - 1) : this.imageIndex--;
  }

  nextImage() {
    this.internalImages.length - 1 === this.imageIndex ? (this.imageIndex = 0) : this.imageIndex++;
  }

  render() {
      return (
        <Host>
          <div class="container">
            <lilu-img url={this.dataProductUrl} src={this.internalImages[this.imageIndex]}/>
            <div class={`controls ${this.showControls ? 'show' : ''}`}>
              <button class="control prev" onClick={this.previousImage.bind(this)}></button>
              <button class="control next" onClick={this.nextImage.bind(this)}></button>
            </div>
          </div>
        </Host>
      );
  }
}
